import { createTheme } from '@mui/material/styles';
import { paletteClaro, paletteEscuro } from './palette';
import { typography } from './typography';
import { components } from './components';
import { shadows } from './shadows';

export const obterTemaPremium = (mode: 'light' | 'dark') => {
  return createTheme({
    palette: mode === 'light' ? paletteClaro : paletteEscuro,
    typography,
    shadows,
    components,
  });
};

// Default export para compatibilidade legado (padrão claro)
const theme = obterTemaPremium('light');
export default theme;
export * from './shadows';
